module.exports = __webpack_public_path__ + "img/P50-en.59d7b470.png";